// Generated by purs version 0.15.15
import * as Data_Argonaut_Core from "../Data.Argonaut.Core/index.js";
import * as Data_Argonaut_Decode_Class from "../Data.Argonaut.Decode.Class/index.js";
import * as Data_Argonaut_Decode_Generic from "../Data.Argonaut.Decode.Generic/index.js";
import * as Data_Argonaut_Encode_Class from "../Data.Argonaut.Encode.Class/index.js";
import * as Data_Argonaut_Encode_Generic from "../Data.Argonaut.Encode.Generic/index.js";
import * as Data_Array_NonEmpty_Internal from "../Data.Array.NonEmpty.Internal/index.js";
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Generic_Rep from "../Data.Generic.Rep/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Data_Show_Generic from "../Data.Show.Generic/index.js";
import * as Data_Tuple from "../Data.Tuple/index.js";
import * as Fusion_Data_Duration from "../Fusion.Data.Duration/index.js";
import * as Fusion_Data_FSWarning from "../Fusion.Data.FSWarning/index.js";
import * as Fusion_Data_Speed from "../Fusion.Data.Speed/index.js";
import * as MST_Data_BasicURL from "../MST.Data.BasicURL/index.js";
import * as MST_Encoding from "../MST.Encoding/index.js";
var genericShowConstructor = /* #__PURE__ */ Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments);
var NotNeededIsSymbol = {
    reflectSymbol: function () {
        return "NotNeeded";
    }
};
var NotAvailableIsSymbol = {
    reflectSymbol: function () {
        return "NotAvailable";
    }
};
var NotACustomerIsSymbol = {
    reflectSymbol: function () {
        return "NotACustomer";
    }
};
var showRecord = /* #__PURE__ */ Data_Show.showRecord()();
var speedIsSymbol = {
    reflectSymbol: function () {
        return "speed";
    }
};
var showRecordFieldsConsNil = /* #__PURE__ */ Data_Show.showRecordFieldsConsNil(speedIsSymbol)(Fusion_Data_Speed.showSpeed);
var showRecord1 = /* #__PURE__ */ showRecord(showRecordFieldsConsNil);
var ModemFinalAvailableIsSymbol = {
    reflectSymbol: function () {
        return "ModemFinalAvailable";
    }
};
var reasonIsSymbol = {
    reflectSymbol: function () {
        return "reason";
    }
};
var ModemFinalDidNotRunIsSymbol = {
    reflectSymbol: function () {
        return "ModemFinalDidNotRun";
    }
};
var messageIsSymbol = {
    reflectSymbol: function () {
        return "message";
    }
};
var showMaybe = /* #__PURE__ */ Data_Maybe.showMaybe(Data_Show.showString);
var ModemFinalFailedIsSymbol = {
    reflectSymbol: function () {
        return "ModemFinalFailed";
    }
};
var IPv4IsSymbol = {
    reflectSymbol: function () {
        return "IPv4";
    }
};
var IPv6IsSymbol = {
    reflectSymbol: function () {
        return "IPv6";
    }
};
var infoIsSymbol = {
    reflectSymbol: function () {
        return "info";
    }
};
var initIsSymbol = {
    reflectSymbol: function () {
        return "init";
    }
};
var stepDetailsIsSymbol = {
    reflectSymbol: function () {
        return "stepDetails";
    }
};
var downloadIsSymbol = {
    reflectSymbol: function () {
        return "download";
    }
};
var uploadIsSymbol = {
    reflectSymbol: function () {
        return "upload";
    }
};
var durationIsSymbol = {
    reflectSymbol: function () {
        return "duration";
    }
};
var showRecordFieldsCons = /* #__PURE__ */ Data_Show.showRecordFieldsCons(durationIsSymbol);
var numStreamsIsSymbol = {
    reflectSymbol: function () {
        return "numStreams";
    }
};
var uploadAddressIsSymbol = {
    reflectSymbol: function () {
        return "uploadAddress";
    }
};
var loadIsSymbol = {
    reflectSymbol: function () {
        return "load";
    }
};
var progressIsSymbol = {
    reflectSymbol: function () {
        return "progress";
    }
};
var statsIsSymbol = {
    reflectSymbol: function () {
        return "stats";
    }
};
var showMaybe1 = /* #__PURE__ */ Data_Maybe.showMaybe(MST_Data_BasicURL.showBasicURL);
var showRecord2 = /* #__PURE__ */ showRecord(/* #__PURE__ */ Data_Show.showRecordFieldsCons(loadIsSymbol)(/* #__PURE__ */ Data_Show.showRecordFieldsCons(progressIsSymbol)(/* #__PURE__ */ Data_Show.showRecordFieldsConsNil(statsIsSymbol)(showMaybe1))(showMaybe1))(MST_Data_BasicURL.showBasicURL));
var downloadAddressesIsSymbol = {
    reflectSymbol: function () {
        return "downloadAddresses";
    }
};
var clientIsSymbol = {
    reflectSymbol: function () {
        return "client";
    }
};
var connectionIsSymbol = {
    reflectSymbol: function () {
        return "connection";
    }
};
var ipIsSymbol = {
    reflectSymbol: function () {
        return "ip";
    }
};
var ipVersionIsSymbol = {
    reflectSymbol: function () {
        return "ipVersion";
    }
};
var ispIsSymbol = {
    reflectSymbol: function () {
        return "isp";
    }
};
var userAgentIsSymbol = {
    reflectSymbol: function () {
        return "userAgent";
    }
};
var contractInfoIsSymbol = {
    reflectSymbol: function () {
        return "contractInfo";
    }
};
var speedtestIDIsSymbol = {
    reflectSymbol: function () {
        return "speedtestID";
    }
};
var maxDownloadBookedSpeedIsSymbol = {
    reflectSymbol: function () {
        return "maxDownloadBookedSpeed";
    }
};
var maxDownloadProvisionedSpeedIsSymbol = {
    reflectSymbol: function () {
        return "maxDownloadProvisionedSpeed";
    }
};
var maxUploadBookedSpeedIsSymbol = {
    reflectSymbol: function () {
        return "maxUploadBookedSpeed";
    }
};
var maxUploadProvisionedSpeedIsSymbol = {
    reflectSymbol: function () {
        return "maxUploadProvisionedSpeed";
    }
};
var showMaybe2 = /* #__PURE__ */ Data_Maybe.showMaybe(Fusion_Data_Speed.showSpeed);
var show = /* #__PURE__ */ Data_Show.show(showRecord1);
var jitterIsSymbol = {
    reflectSymbol: function () {
        return "jitter";
    }
};
var showRecordFieldsCons1 = /* #__PURE__ */ Data_Show.showRecordFieldsCons(jitterIsSymbol);
var show1 = /* #__PURE__ */ Data_Show.show(/* #__PURE__ */ showRecord(/* #__PURE__ */ showRecordFieldsCons1(showRecordFieldsConsNil)(Fusion_Data_Speed.showSpeed)));
var pingTimeIsSymbol = {
    reflectSymbol: function () {
        return "pingTime";
    }
};
var showRecordFieldsConsNil1 = /* #__PURE__ */ Data_Show.showRecordFieldsConsNil(pingTimeIsSymbol)(Fusion_Data_Duration.showDuration);
var show2 = /* #__PURE__ */ Data_Show.show(/* #__PURE__ */ showRecord(showRecordFieldsConsNil1));
var show3 = /* #__PURE__ */ Data_Show.show(/* #__PURE__ */ showRecord(/* #__PURE__ */ showRecordFieldsCons1(showRecordFieldsConsNil1)(Fusion_Data_Duration.showDuration)));
var modemFinalIsSymbol = {
    reflectSymbol: function () {
        return "modemFinal";
    }
};
var show4 = /* #__PURE__ */ Data_Show.show(Fusion_Data_FSWarning.showFSWarning);
var eq = /* #__PURE__ */ Data_Eq.eq(Fusion_Data_Speed.eqSpeed);
var eq1 = /* #__PURE__ */ Data_Eq.eq(/* #__PURE__ */ Data_Maybe.eqMaybe(Data_Eq.eqString));
var eq2 = /* #__PURE__ */ Data_Eq.eq(/* #__PURE__ */ Data_Maybe.eqMaybe(Fusion_Data_Speed.eqSpeed));
var eqMaybe = /* #__PURE__ */ Data_Maybe.eqMaybe(MST_Data_BasicURL.eqBasicURL);
var eq4 = /* #__PURE__ */ Data_Eq.eq(/* #__PURE__ */ Data_Array_NonEmpty_Internal.eqNonEmptyArray(/* #__PURE__ */ Data_Eq.eqRec()(/* #__PURE__ */ Data_Eq.eqRowCons(/* #__PURE__ */ Data_Eq.eqRowCons(/* #__PURE__ */ Data_Eq.eqRowCons(Data_Eq.eqRowNil)()(statsIsSymbol)(eqMaybe))()(progressIsSymbol)(eqMaybe))()(loadIsSymbol)(MST_Data_BasicURL.eqBasicURL))));
var eq5 = /* #__PURE__ */ Data_Eq.eq(Fusion_Data_Duration.eqDuration);
var eq7 = /* #__PURE__ */ Data_Eq.eq(MST_Data_BasicURL.eqBasicURL);
var eq8 = /* #__PURE__ */ Data_Eq.eq(eqMaybe);
var eq9 = /* #__PURE__ */ Data_Eq.eq(Fusion_Data_FSWarning.eqFSWarning);
var eq10 = /* #__PURE__ */ Data_Eq.eq(Data_Argonaut_Core.eqJson);
var gEncodeJsonCons = /* #__PURE__ */ Data_Argonaut_Encode_Class.gEncodeJsonCons(Fusion_Data_Speed.encodeJsonSpeed);
var gEncodeJsonCons1 = /* #__PURE__ */ gEncodeJsonCons(Data_Argonaut_Encode_Class.gEncodeJsonNil)(speedIsSymbol)();
var encodeRepArgsArgument = /* #__PURE__ */ Data_Argonaut_Encode_Generic.encodeRepArgsArgument(/* #__PURE__ */ Data_Argonaut_Encode_Class.encodeRecord(gEncodeJsonCons1)());
var gEncodeJsonCons2 = /* #__PURE__ */ Data_Argonaut_Encode_Class.gEncodeJsonCons(/* #__PURE__ */ Data_Argonaut_Encode_Class.encodeJsonMaybe(Data_Argonaut_Encode_Class.encodeJsonJString))(Data_Argonaut_Encode_Class.gEncodeJsonNil);
var PrepareResultIsSymbol = {
    reflectSymbol: function () {
        return "PrepareResult";
    }
};
var gEncodeJsonCons3 = /* #__PURE__ */ Data_Argonaut_Encode_Class.gEncodeJsonCons(/* #__PURE__ */ Data_Argonaut_Encode_Class.encodeJsonMaybe(Fusion_Data_Speed.encodeJsonSpeed));
var gEncodeJsonCons4 = /* #__PURE__ */ Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonJString);
var gEncodeJsonCons5 = /* #__PURE__ */ Data_Argonaut_Encode_Class.gEncodeJsonCons(/* #__PURE__ */ Data_Argonaut_Encode_Class.encodeJsonMaybe(MST_Data_BasicURL.encodeJsonBasicURL));
var encodeRecord = /* #__PURE__ */ Data_Argonaut_Encode_Class.encodeRecord(/* #__PURE__ */ Data_Argonaut_Encode_Class.gEncodeJsonCons(MST_Data_BasicURL.encodeJsonBasicURL)(/* #__PURE__ */ gEncodeJsonCons5(/* #__PURE__ */ gEncodeJsonCons5(Data_Argonaut_Encode_Class.gEncodeJsonNil)(statsIsSymbol)())(progressIsSymbol)())(loadIsSymbol)())();
var gEncodeJsonCons6 = /* #__PURE__ */ Data_Argonaut_Encode_Class.gEncodeJsonCons(Fusion_Data_Duration.encodeJsonDuration);
var gEncodeJsonCons7 = /* #__PURE__ */ Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonInt);
var DownloadIntermediateIsSymbol = {
    reflectSymbol: function () {
        return "DownloadIntermediate";
    }
};
var DownloadFinalIsSymbol = {
    reflectSymbol: function () {
        return "DownloadFinal";
    }
};
var encodeRepArgsArgument1 = /* #__PURE__ */ Data_Argonaut_Encode_Generic.encodeRepArgsArgument(/* #__PURE__ */ Data_Argonaut_Encode_Class.encodeRecord(/* #__PURE__ */ gEncodeJsonCons(gEncodeJsonCons1)(jitterIsSymbol)())());
var UploadIntermediateIsSymbol = {
    reflectSymbol: function () {
        return "UploadIntermediate";
    }
};
var UploadFinalIsSymbol = {
    reflectSymbol: function () {
        return "UploadFinal";
    }
};
var PingIntermediateIsSymbol = {
    reflectSymbol: function () {
        return "PingIntermediate";
    }
};
var gEncodeJsonCons8 = /* #__PURE__ */ gEncodeJsonCons6(Data_Argonaut_Encode_Class.gEncodeJsonNil)(pingTimeIsSymbol)();
var PingFinalIsSymbol = {
    reflectSymbol: function () {
        return "PingFinal";
    }
};
var ModemFinalIsSymbol = {
    reflectSymbol: function () {
        return "ModemFinal";
    }
};
var WarningIsSymbol = {
    reflectSymbol: function () {
        return "Warning";
    }
};
var FusionDownloadOutputIsSymbol = {
    reflectSymbol: function () {
        return "FusionDownloadOutput";
    }
};
var loadOutputIsSymbol = {
    reflectSymbol: function () {
        return "loadOutput";
    }
};
var gDecodeJsonCons = /* #__PURE__ */ Data_Argonaut_Decode_Class.gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeFieldId(Fusion_Data_Speed.decodeJsonSpeed));
var gDecodeJsonCons1 = /* #__PURE__ */ gDecodeJsonCons(Data_Argonaut_Decode_Class.gDecodeJsonNil)(speedIsSymbol)()();
var decodeRecord = /* #__PURE__ */ Data_Argonaut_Decode_Class.decodeRecord(gDecodeJsonCons1)();
var gDecodeJsonCons2 = /* #__PURE__ */ Data_Argonaut_Decode_Class.gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeFieldMaybe(Data_Argonaut_Decode_Class.decodeJsonString))(Data_Argonaut_Decode_Class.gDecodeJsonNil);
var gDecodeJsonCons3 = /* #__PURE__ */ Data_Argonaut_Decode_Class.gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeFieldMaybe(Fusion_Data_Speed.decodeJsonSpeed));
var gDecodeJsonCons4 = /* #__PURE__ */ Data_Argonaut_Decode_Class.gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonString));
var gDecodeJsonCons5 = /* #__PURE__ */ Data_Argonaut_Decode_Class.gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeFieldMaybe(MST_Data_BasicURL.decodeJsonBasicURL));
var decodeRecord1 = /* #__PURE__ */ Data_Argonaut_Decode_Class.decodeRecord(/* #__PURE__ */ Data_Argonaut_Decode_Class.gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeFieldId(MST_Data_BasicURL.decodeJsonBasicURL))(/* #__PURE__ */ gDecodeJsonCons5(/* #__PURE__ */ gDecodeJsonCons5(Data_Argonaut_Decode_Class.gDecodeJsonNil)(statsIsSymbol)()())(progressIsSymbol)()())(loadIsSymbol)()())();
var gDecodeJsonCons6 = /* #__PURE__ */ Data_Argonaut_Decode_Class.gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeFieldId(Fusion_Data_Duration.decodeJsonDuration));
var gDecodeJsonCons7 = /* #__PURE__ */ Data_Argonaut_Decode_Class.gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonInt));
var decodeRecord2 = /* #__PURE__ */ Data_Argonaut_Decode_Class.decodeRecord(/* #__PURE__ */ gDecodeJsonCons(gDecodeJsonCons1)(jitterIsSymbol)()())();
var gDecodeJsonCons8 = /* #__PURE__ */ gDecodeJsonCons6(Data_Argonaut_Decode_Class.gDecodeJsonNil)(pingTimeIsSymbol)()();
var NotNeeded = /* #__PURE__ */ (function () {
    function NotNeeded() {

    };
    NotNeeded.value = new NotNeeded();
    return NotNeeded;
})();
var NotAvailable = /* #__PURE__ */ (function () {
    function NotAvailable() {

    };
    NotAvailable.value = new NotAvailable();
    return NotAvailable;
})();
var NotACustomer = /* #__PURE__ */ (function () {
    function NotACustomer() {

    };
    NotACustomer.value = new NotACustomer();
    return NotACustomer;
})();
var ModemFinalAvailable = /* #__PURE__ */ (function () {
    function ModemFinalAvailable(value0) {
        this.value0 = value0;
    };
    ModemFinalAvailable.create = function (value0) {
        return new ModemFinalAvailable(value0);
    };
    return ModemFinalAvailable;
})();
var ModemFinalDidNotRun = /* #__PURE__ */ (function () {
    function ModemFinalDidNotRun(value0) {
        this.value0 = value0;
    };
    ModemFinalDidNotRun.create = function (value0) {
        return new ModemFinalDidNotRun(value0);
    };
    return ModemFinalDidNotRun;
})();
var ModemFinalFailed = /* #__PURE__ */ (function () {
    function ModemFinalFailed(value0) {
        this.value0 = value0;
    };
    ModemFinalFailed.create = function (value0) {
        return new ModemFinalFailed(value0);
    };
    return ModemFinalFailed;
})();
var IPv4 = /* #__PURE__ */ (function () {
    function IPv4() {

    };
    IPv4.value = new IPv4();
    return IPv4;
})();
var IPv6 = /* #__PURE__ */ (function () {
    function IPv6() {

    };
    IPv6.value = new IPv6();
    return IPv6;
})();
var PrepareResult = /* #__PURE__ */ (function () {
    function PrepareResult(value0) {
        this.value0 = value0;
    };
    PrepareResult.create = function (value0) {
        return new PrepareResult(value0);
    };
    return PrepareResult;
})();
var DownloadIntermediate = /* #__PURE__ */ (function () {
    function DownloadIntermediate(value0) {
        this.value0 = value0;
    };
    DownloadIntermediate.create = function (value0) {
        return new DownloadIntermediate(value0);
    };
    return DownloadIntermediate;
})();
var DownloadFinal = /* #__PURE__ */ (function () {
    function DownloadFinal(value0) {
        this.value0 = value0;
    };
    DownloadFinal.create = function (value0) {
        return new DownloadFinal(value0);
    };
    return DownloadFinal;
})();
var UploadIntermediate = /* #__PURE__ */ (function () {
    function UploadIntermediate(value0) {
        this.value0 = value0;
    };
    UploadIntermediate.create = function (value0) {
        return new UploadIntermediate(value0);
    };
    return UploadIntermediate;
})();
var UploadFinal = /* #__PURE__ */ (function () {
    function UploadFinal(value0) {
        this.value0 = value0;
    };
    UploadFinal.create = function (value0) {
        return new UploadFinal(value0);
    };
    return UploadFinal;
})();
var PingIntermediate = /* #__PURE__ */ (function () {
    function PingIntermediate(value0) {
        this.value0 = value0;
    };
    PingIntermediate.create = function (value0) {
        return new PingIntermediate(value0);
    };
    return PingIntermediate;
})();
var PingFinal = /* #__PURE__ */ (function () {
    function PingFinal(value0) {
        this.value0 = value0;
    };
    PingFinal.create = function (value0) {
        return new PingFinal(value0);
    };
    return PingFinal;
})();
var ModemFinal = /* #__PURE__ */ (function () {
    function ModemFinal(value0) {
        this.value0 = value0;
    };
    ModemFinal.create = function (value0) {
        return new ModemFinal(value0);
    };
    return ModemFinal;
})();
var Warning = /* #__PURE__ */ (function () {
    function Warning(value0) {
        this.value0 = value0;
    };
    Warning.create = function (value0) {
        return new Warning(value0);
    };
    return Warning;
})();
var FusionDownloadOutput = /* #__PURE__ */ (function () {
    function FusionDownloadOutput(value0) {
        this.value0 = value0;
    };
    FusionDownloadOutput.create = function (value0) {
        return new FusionDownloadOutput(value0);
    };
    return FusionDownloadOutput;
})();
var genericModemNotRunReason_ = {
    to: function (x) {
        if (x instanceof Data_Generic_Rep.Inl) {
            return NotNeeded.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && x.value0 instanceof Data_Generic_Rep.Inl) {
            return NotAvailable.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && x.value0 instanceof Data_Generic_Rep.Inr) {
            return NotACustomer.value;
        };
        throw new Error("Failed pattern match at Fusion.Data.FSValue (line 210, column 1 - line 210, column 44): " + [ x.constructor.name ]);
    },
    from: function (x) {
        if (x instanceof NotNeeded) {
            return new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value);
        };
        if (x instanceof NotAvailable) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value));
        };
        if (x instanceof NotACustomer) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(Data_Generic_Rep.NoArguments.value));
        };
        throw new Error("Failed pattern match at Fusion.Data.FSValue (line 210, column 1 - line 210, column 44): " + [ x.constructor.name ]);
    }
};
var showModemNotRunReason = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericModemNotRunReason_)(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ genericShowConstructor(NotNeededIsSymbol))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ genericShowConstructor(NotAvailableIsSymbol))(/* #__PURE__ */ genericShowConstructor(NotACustomerIsSymbol))))
};
var genericModemFinalResult_ = {
    to: function (x) {
        if (x instanceof Data_Generic_Rep.Inl) {
            return new ModemFinalAvailable(x.value0);
        };
        if (x instanceof Data_Generic_Rep.Inr && x.value0 instanceof Data_Generic_Rep.Inl) {
            return new ModemFinalDidNotRun(x.value0.value0);
        };
        if (x instanceof Data_Generic_Rep.Inr && x.value0 instanceof Data_Generic_Rep.Inr) {
            return new ModemFinalFailed(x.value0.value0);
        };
        throw new Error("Failed pattern match at Fusion.Data.FSValue (line 199, column 1 - line 199, column 43): " + [ x.constructor.name ]);
    },
    from: function (x) {
        if (x instanceof ModemFinalAvailable) {
            return new Data_Generic_Rep.Inl(x.value0);
        };
        if (x instanceof ModemFinalDidNotRun) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0));
        };
        if (x instanceof ModemFinalFailed) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(x.value0));
        };
        throw new Error("Failed pattern match at Fusion.Data.FSValue (line 199, column 1 - line 199, column 43): " + [ x.constructor.name ]);
    }
};
var showModemFinalResult = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericModemFinalResult_)(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(showRecord1))(ModemFinalAvailableIsSymbol))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(/* #__PURE__ */ showRecord(/* #__PURE__ */ Data_Show.showRecordFieldsConsNil(reasonIsSymbol)(showModemNotRunReason))))(ModemFinalDidNotRunIsSymbol))(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(/* #__PURE__ */ showRecord(/* #__PURE__ */ Data_Show.showRecordFieldsConsNil(messageIsSymbol)(showMaybe))))(ModemFinalFailedIsSymbol))))
};
var show5 = /* #__PURE__ */ Data_Show.show(/* #__PURE__ */ showRecord(/* #__PURE__ */ Data_Show.showRecordFieldsConsNil(modemFinalIsSymbol)(showModemFinalResult)));
var genericIpVersion_ = {
    to: function (x) {
        if (x instanceof Data_Generic_Rep.Inl) {
            return IPv4.value;
        };
        if (x instanceof Data_Generic_Rep.Inr) {
            return IPv6.value;
        };
        throw new Error("Failed pattern match at Fusion.Data.FSValue (line 188, column 1 - line 188, column 36): " + [ x.constructor.name ]);
    },
    from: function (x) {
        if (x instanceof IPv4) {
            return new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value);
        };
        if (x instanceof IPv6) {
            return new Data_Generic_Rep.Inr(Data_Generic_Rep.NoArguments.value);
        };
        throw new Error("Failed pattern match at Fusion.Data.FSValue (line 188, column 1 - line 188, column 36): " + [ x.constructor.name ]);
    }
};
var showIpVersion = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericIpVersion_)(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ genericShowConstructor(IPv4IsSymbol))(/* #__PURE__ */ genericShowConstructor(IPv6IsSymbol)))
};
var show6 = /* #__PURE__ */ Data_Show.show(/* #__PURE__ */ showRecord(/* #__PURE__ */ Data_Show.showRecordFieldsCons(infoIsSymbol)(/* #__PURE__ */ Data_Show.showRecordFieldsCons(initIsSymbol)(/* #__PURE__ */ Data_Show.showRecordFieldsConsNil(stepDetailsIsSymbol)(/* #__PURE__ */ showRecord(/* #__PURE__ */ Data_Show.showRecordFieldsCons(downloadIsSymbol)(/* #__PURE__ */ Data_Show.showRecordFieldsConsNil(uploadIsSymbol)(/* #__PURE__ */ showRecord(/* #__PURE__ */ showRecordFieldsCons(/* #__PURE__ */ Data_Show.showRecordFieldsCons(numStreamsIsSymbol)(/* #__PURE__ */ Data_Show.showRecordFieldsConsNil(uploadAddressIsSymbol)(showRecord2))(Data_Show.showInt))(Fusion_Data_Duration.showDuration))))(/* #__PURE__ */ showRecord(/* #__PURE__ */ Data_Show.showRecordFieldsCons(downloadAddressesIsSymbol)(/* #__PURE__ */ showRecordFieldsCons(/* #__PURE__ */ Data_Show.showRecordFieldsConsNil(numStreamsIsSymbol)(Data_Show.showInt))(Fusion_Data_Duration.showDuration))(/* #__PURE__ */ Data_Array_NonEmpty_Internal.showNonEmptyArray(showRecord2)))))))(/* #__PURE__ */ showRecord(/* #__PURE__ */ Data_Show.showRecordFieldsCons(clientIsSymbol)(/* #__PURE__ */ Data_Show.showRecordFieldsConsNil(connectionIsSymbol)(/* #__PURE__ */ showRecord(/* #__PURE__ */ Data_Show.showRecordFieldsCons(ipIsSymbol)(/* #__PURE__ */ Data_Show.showRecordFieldsCons(ipVersionIsSymbol)(/* #__PURE__ */ Data_Show.showRecordFieldsConsNil(ispIsSymbol)(showMaybe))(showIpVersion))(Data_Show.showString))))(/* #__PURE__ */ showRecord(/* #__PURE__ */ Data_Show.showRecordFieldsConsNil(userAgentIsSymbol)(showMaybe))))))(/* #__PURE__ */ showRecord(/* #__PURE__ */ Data_Show.showRecordFieldsCons(contractInfoIsSymbol)(/* #__PURE__ */ Data_Show.showRecordFieldsConsNil(speedtestIDIsSymbol)(Data_Show.showString))(/* #__PURE__ */ showRecord(/* #__PURE__ */ Data_Show.showRecordFieldsCons(maxDownloadBookedSpeedIsSymbol)(/* #__PURE__ */ Data_Show.showRecordFieldsCons(maxDownloadProvisionedSpeedIsSymbol)(/* #__PURE__ */ Data_Show.showRecordFieldsCons(maxUploadBookedSpeedIsSymbol)(/* #__PURE__ */ Data_Show.showRecordFieldsConsNil(maxUploadProvisionedSpeedIsSymbol)(showMaybe2))(showMaybe2))(showMaybe2))(showMaybe2)))))));
var showFSValue = {
    show: function (v) {
        var v1 = (function () {
            if (v instanceof PrepareResult) {
                return new Data_Tuple.Tuple("PrepareResult", show6(v.value0));
            };
            if (v instanceof DownloadIntermediate) {
                return new Data_Tuple.Tuple("DownloadIntermediate", show(v.value0));
            };
            if (v instanceof DownloadFinal) {
                return new Data_Tuple.Tuple("DownloadFinal", show1(v.value0));
            };
            if (v instanceof UploadIntermediate) {
                return new Data_Tuple.Tuple("UploadIntermediate", show(v.value0));
            };
            if (v instanceof UploadFinal) {
                return new Data_Tuple.Tuple("UploadFinal", show1(v.value0));
            };
            if (v instanceof PingIntermediate) {
                return new Data_Tuple.Tuple("PingIntermediate", show2(v.value0));
            };
            if (v instanceof PingFinal) {
                return new Data_Tuple.Tuple("PingFinal", show3(v.value0));
            };
            if (v instanceof ModemFinal) {
                return new Data_Tuple.Tuple("ModemFinal", show5(v.value0));
            };
            if (v instanceof Warning) {
                return new Data_Tuple.Tuple("Warning", show4(v.value0));
            };
            if (v instanceof FusionDownloadOutput) {
                return new Data_Tuple.Tuple("FusionDownloadOutput", "<JSON>");
            };
            throw new Error("Failed pattern match at Fusion.Data.FSValue (line 168, column 18 - line 178, column 69): " + [ v.constructor.name ]);
        })();
        return "(" + (v1.value0 + (" " + (v1.value1 + ")")));
    }
};
var genericFSValue_ = {
    to: function (x) {
        if (x instanceof Data_Generic_Rep.Inl) {
            return new PrepareResult(x.value0);
        };
        if (x instanceof Data_Generic_Rep.Inr && x.value0 instanceof Data_Generic_Rep.Inl) {
            return new DownloadIntermediate(x.value0.value0);
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0 instanceof Data_Generic_Rep.Inl)) {
            return new DownloadFinal(x.value0.value0.value0);
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0 instanceof Data_Generic_Rep.Inl))) {
            return new UploadIntermediate(x.value0.value0.value0.value0);
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl)))) {
            return new UploadFinal(x.value0.value0.value0.value0.value0);
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl))))) {
            return new PingIntermediate(x.value0.value0.value0.value0.value0.value0);
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl)))))) {
            return new PingFinal(x.value0.value0.value0.value0.value0.value0.value0);
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl))))))) {
            return new ModemFinal(x.value0.value0.value0.value0.value0.value0.value0.value0);
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl)))))))) {
            return new Warning(x.value0.value0.value0.value0.value0.value0.value0.value0.value0);
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr)))))))) {
            return new FusionDownloadOutput(x.value0.value0.value0.value0.value0.value0.value0.value0.value0);
        };
        throw new Error("Failed pattern match at Fusion.Data.FSValue (line 163, column 1 - line 163, column 34): " + [ x.constructor.name ]);
    },
    from: function (x) {
        if (x instanceof PrepareResult) {
            return new Data_Generic_Rep.Inl(x.value0);
        };
        if (x instanceof DownloadIntermediate) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0));
        };
        if (x instanceof DownloadFinal) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0)));
        };
        if (x instanceof UploadIntermediate) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0))));
        };
        if (x instanceof UploadFinal) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0)))));
        };
        if (x instanceof PingIntermediate) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0))))));
        };
        if (x instanceof PingFinal) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0)))))));
        };
        if (x instanceof ModemFinal) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0))))))));
        };
        if (x instanceof Warning) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0)))))))));
        };
        if (x instanceof FusionDownloadOutput) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(x.value0)))))))));
        };
        throw new Error("Failed pattern match at Fusion.Data.FSValue (line 163, column 1 - line 163, column 34): " + [ x.constructor.name ]);
    }
};
var eqModemNotRunReason = {
    eq: function (x) {
        return function (y) {
            if (x instanceof NotNeeded && y instanceof NotNeeded) {
                return true;
            };
            if (x instanceof NotAvailable && y instanceof NotAvailable) {
                return true;
            };
            if (x instanceof NotACustomer && y instanceof NotACustomer) {
                return true;
            };
            return false;
        };
    }
};
var eq11 = /* #__PURE__ */ Data_Eq.eq(eqModemNotRunReason);
var eqModemFinalResult = {
    eq: function (x) {
        return function (y) {
            if (x instanceof ModemFinalAvailable && y instanceof ModemFinalAvailable) {
                return eq(x.value0.speed)(y.value0.speed);
            };
            if (x instanceof ModemFinalDidNotRun && y instanceof ModemFinalDidNotRun) {
                return eq11(x.value0.reason)(y.value0.reason);
            };
            if (x instanceof ModemFinalFailed && y instanceof ModemFinalFailed) {
                return eq1(x.value0.message)(y.value0.message);
            };
            return false;
        };
    }
};
var eq12 = /* #__PURE__ */ Data_Eq.eq(eqModemFinalResult);
var eqIpVersion = {
    eq: function (x) {
        return function (y) {
            if (x instanceof IPv4 && y instanceof IPv4) {
                return true;
            };
            if (x instanceof IPv6 && y instanceof IPv6) {
                return true;
            };
            return false;
        };
    }
};
var eq13 = /* #__PURE__ */ Data_Eq.eq(eqIpVersion);
var eqFSValue = {
    eq: function (x) {
        return function (y) {
            if (x instanceof PrepareResult && y instanceof PrepareResult) {
                return eq2(x.value0.info.contractInfo.maxDownloadBookedSpeed)(y.value0.info.contractInfo.maxDownloadBookedSpeed) && eq2(x.value0.info.contractInfo.maxDownloadProvisionedSpeed)(y.value0.info.contractInfo.maxDownloadProvisionedSpeed) && eq2(x.value0.info.contractInfo.maxUploadBookedSpeed)(y.value0.info.contractInfo.maxUploadBookedSpeed) && eq2(x.value0.info.contractInfo.maxUploadProvisionedSpeed)(y.value0.info.contractInfo.maxUploadProvisionedSpeed) && x.value0.info.speedtestID === y.value0.info.speedtestID && (eq1(x.value0.init.client.userAgent)(y.value0.init.client.userAgent) && (x.value0.init.connection.ip === y.value0.init.connection.ip && eq13(x.value0.init.connection.ipVersion)(y.value0.init.connection.ipVersion) && eq1(x.value0.init.connection.isp)(y.value0.init.connection.isp))) && (eq4(x.value0.stepDetails.download.downloadAddresses)(y.value0.stepDetails.download.downloadAddresses) && eq5(x.value0.stepDetails.download.duration)(y.value0.stepDetails.download.duration) && x.value0.stepDetails.download.numStreams === y.value0.stepDetails.download.numStreams && (eq5(x.value0.stepDetails.upload.duration)(y.value0.stepDetails.upload.duration) && x.value0.stepDetails.upload.numStreams === y.value0.stepDetails.upload.numStreams && (eq7(x.value0.stepDetails.upload.uploadAddress.load)(y.value0.stepDetails.upload.uploadAddress.load) && eq8(x.value0.stepDetails.upload.uploadAddress.progress)(y.value0.stepDetails.upload.uploadAddress.progress) && eq8(x.value0.stepDetails.upload.uploadAddress.stats)(y.value0.stepDetails.upload.uploadAddress.stats))));
            };
            if (x instanceof DownloadIntermediate && y instanceof DownloadIntermediate) {
                return eq(x.value0.speed)(y.value0.speed);
            };
            if (x instanceof DownloadFinal && y instanceof DownloadFinal) {
                return eq(x.value0.jitter)(y.value0.jitter) && eq(x.value0.speed)(y.value0.speed);
            };
            if (x instanceof UploadIntermediate && y instanceof UploadIntermediate) {
                return eq(x.value0.speed)(y.value0.speed);
            };
            if (x instanceof UploadFinal && y instanceof UploadFinal) {
                return eq(x.value0.jitter)(y.value0.jitter) && eq(x.value0.speed)(y.value0.speed);
            };
            if (x instanceof PingIntermediate && y instanceof PingIntermediate) {
                return eq5(x.value0.pingTime)(y.value0.pingTime);
            };
            if (x instanceof PingFinal && y instanceof PingFinal) {
                return eq5(x.value0.jitter)(y.value0.jitter) && eq5(x.value0.pingTime)(y.value0.pingTime);
            };
            if (x instanceof ModemFinal && y instanceof ModemFinal) {
                return eq12(x.value0.modemFinal)(y.value0.modemFinal);
            };
            if (x instanceof Warning && y instanceof Warning) {
                return eq9(x.value0)(y.value0);
            };
            if (x instanceof FusionDownloadOutput && y instanceof FusionDownloadOutput) {
                return eq10(x.value0.loadOutput)(y.value0.loadOutput);
            };
            return false;
        };
    }
};
var encodeJsonModemNotRunReas = {
    encodeJson: /* #__PURE__ */ MST_Encoding.genericEncodeJsonVisonum(genericModemNotRunReason_)(/* #__PURE__ */ Data_Argonaut_Encode_Generic.encodeRepSum(/* #__PURE__ */ Data_Argonaut_Encode_Generic.encodeRepConstructor(NotNeededIsSymbol)(Data_Argonaut_Encode_Generic.encodeRepArgsNoArguments))(/* #__PURE__ */ Data_Argonaut_Encode_Generic.encodeRepSum(/* #__PURE__ */ Data_Argonaut_Encode_Generic.encodeRepConstructor(NotAvailableIsSymbol)(Data_Argonaut_Encode_Generic.encodeRepArgsNoArguments))(/* #__PURE__ */ Data_Argonaut_Encode_Generic.encodeRepConstructor(NotACustomerIsSymbol)(Data_Argonaut_Encode_Generic.encodeRepArgsNoArguments))))
};
var encodeJsonModemFinalResul = {
    encodeJson: /* #__PURE__ */ MST_Encoding.genericEncodeJsonVisonum(genericModemFinalResult_)(/* #__PURE__ */ Data_Argonaut_Encode_Generic.encodeRepSum(/* #__PURE__ */ Data_Argonaut_Encode_Generic.encodeRepConstructor(ModemFinalAvailableIsSymbol)(encodeRepArgsArgument))(/* #__PURE__ */ Data_Argonaut_Encode_Generic.encodeRepSum(/* #__PURE__ */ Data_Argonaut_Encode_Generic.encodeRepConstructor(ModemFinalDidNotRunIsSymbol)(/* #__PURE__ */ Data_Argonaut_Encode_Generic.encodeRepArgsArgument(/* #__PURE__ */ Data_Argonaut_Encode_Class.encodeRecord(/* #__PURE__ */ Data_Argonaut_Encode_Class.gEncodeJsonCons(encodeJsonModemNotRunReas)(Data_Argonaut_Encode_Class.gEncodeJsonNil)(reasonIsSymbol)())())))(/* #__PURE__ */ Data_Argonaut_Encode_Generic.encodeRepConstructor(ModemFinalFailedIsSymbol)(/* #__PURE__ */ Data_Argonaut_Encode_Generic.encodeRepArgsArgument(/* #__PURE__ */ Data_Argonaut_Encode_Class.encodeRecord(/* #__PURE__ */ gEncodeJsonCons2(messageIsSymbol)())())))))
};
var encodeJsonIpVersion = {
    encodeJson: /* #__PURE__ */ MST_Encoding.genericEncodeJsonVisonum(genericIpVersion_)(/* #__PURE__ */ Data_Argonaut_Encode_Generic.encodeRepSum(/* #__PURE__ */ Data_Argonaut_Encode_Generic.encodeRepConstructor(IPv4IsSymbol)(Data_Argonaut_Encode_Generic.encodeRepArgsNoArguments))(/* #__PURE__ */ Data_Argonaut_Encode_Generic.encodeRepConstructor(IPv6IsSymbol)(Data_Argonaut_Encode_Generic.encodeRepArgsNoArguments)))
};
var encodeJsonFSValue = {
    encodeJson: /* #__PURE__ */ Data_Argonaut_Encode_Generic.genericEncodeJson(genericFSValue_)(/* #__PURE__ */ Data_Argonaut_Encode_Generic.encodeRepSum(/* #__PURE__ */ Data_Argonaut_Encode_Generic.encodeRepConstructor(PrepareResultIsSymbol)(/* #__PURE__ */ Data_Argonaut_Encode_Generic.encodeRepArgsArgument(/* #__PURE__ */ Data_Argonaut_Encode_Class.encodeRecord(/* #__PURE__ */ Data_Argonaut_Encode_Class.gEncodeJsonCons(/* #__PURE__ */ Data_Argonaut_Encode_Class.encodeRecord(/* #__PURE__ */ Data_Argonaut_Encode_Class.gEncodeJsonCons(/* #__PURE__ */ Data_Argonaut_Encode_Class.encodeRecord(/* #__PURE__ */ gEncodeJsonCons3(/* #__PURE__ */ gEncodeJsonCons3(/* #__PURE__ */ gEncodeJsonCons3(/* #__PURE__ */ gEncodeJsonCons3(Data_Argonaut_Encode_Class.gEncodeJsonNil)(maxUploadProvisionedSpeedIsSymbol)())(maxUploadBookedSpeedIsSymbol)())(maxDownloadProvisionedSpeedIsSymbol)())(maxDownloadBookedSpeedIsSymbol)())())(/* #__PURE__ */ gEncodeJsonCons4(Data_Argonaut_Encode_Class.gEncodeJsonNil)(speedtestIDIsSymbol)())(contractInfoIsSymbol)())())(/* #__PURE__ */ Data_Argonaut_Encode_Class.gEncodeJsonCons(/* #__PURE__ */ Data_Argonaut_Encode_Class.encodeRecord(/* #__PURE__ */ Data_Argonaut_Encode_Class.gEncodeJsonCons(/* #__PURE__ */ Data_Argonaut_Encode_Class.encodeRecord(/* #__PURE__ */ gEncodeJsonCons2(userAgentIsSymbol)())())(/* #__PURE__ */ Data_Argonaut_Encode_Class.gEncodeJsonCons(/* #__PURE__ */ Data_Argonaut_Encode_Class.encodeRecord(/* #__PURE__ */ gEncodeJsonCons4(/* #__PURE__ */ Data_Argonaut_Encode_Class.gEncodeJsonCons(encodeJsonIpVersion)(/* #__PURE__ */ gEncodeJsonCons2(ispIsSymbol)())(ipVersionIsSymbol)())(ipIsSymbol)())())(Data_Argonaut_Encode_Class.gEncodeJsonNil)(connectionIsSymbol)())(clientIsSymbol)())())(/* #__PURE__ */ Data_Argonaut_Encode_Class.gEncodeJsonCons(/* #__PURE__ */ Data_Argonaut_Encode_Class.encodeRecord(/* #__PURE__ */ Data_Argonaut_Encode_Class.gEncodeJsonCons(/* #__PURE__ */ Data_Argonaut_Encode_Class.encodeRecord(/* #__PURE__ */ Data_Argonaut_Encode_Class.gEncodeJsonCons(/* #__PURE__ */ Data_Argonaut_Encode_Class.encodeJsonNonEmptyArray(encodeRecord))(/* #__PURE__ */ gEncodeJsonCons6(/* #__PURE__ */ gEncodeJsonCons7(Data_Argonaut_Encode_Class.gEncodeJsonNil)(numStreamsIsSymbol)())(durationIsSymbol)())(downloadAddressesIsSymbol)())())(/* #__PURE__ */ Data_Argonaut_Encode_Class.gEncodeJsonCons(/* #__PURE__ */ Data_Argonaut_Encode_Class.encodeRecord(/* #__PURE__ */ gEncodeJsonCons6(/* #__PURE__ */ gEncodeJsonCons7(/* #__PURE__ */ Data_Argonaut_Encode_Class.gEncodeJsonCons(encodeRecord)(Data_Argonaut_Encode_Class.gEncodeJsonNil)(uploadAddressIsSymbol)())(numStreamsIsSymbol)())(durationIsSymbol)())())(Data_Argonaut_Encode_Class.gEncodeJsonNil)(uploadIsSymbol)())(downloadIsSymbol)())())(Data_Argonaut_Encode_Class.gEncodeJsonNil)(stepDetailsIsSymbol)())(initIsSymbol)())(infoIsSymbol)())())))(/* #__PURE__ */ Data_Argonaut_Encode_Generic.encodeRepSum(/* #__PURE__ */ Data_Argonaut_Encode_Generic.encodeRepConstructor(DownloadIntermediateIsSymbol)(encodeRepArgsArgument))(/* #__PURE__ */ Data_Argonaut_Encode_Generic.encodeRepSum(/* #__PURE__ */ Data_Argonaut_Encode_Generic.encodeRepConstructor(DownloadFinalIsSymbol)(encodeRepArgsArgument1))(/* #__PURE__ */ Data_Argonaut_Encode_Generic.encodeRepSum(/* #__PURE__ */ Data_Argonaut_Encode_Generic.encodeRepConstructor(UploadIntermediateIsSymbol)(encodeRepArgsArgument))(/* #__PURE__ */ Data_Argonaut_Encode_Generic.encodeRepSum(/* #__PURE__ */ Data_Argonaut_Encode_Generic.encodeRepConstructor(UploadFinalIsSymbol)(encodeRepArgsArgument1))(/* #__PURE__ */ Data_Argonaut_Encode_Generic.encodeRepSum(/* #__PURE__ */ Data_Argonaut_Encode_Generic.encodeRepConstructor(PingIntermediateIsSymbol)(/* #__PURE__ */ Data_Argonaut_Encode_Generic.encodeRepArgsArgument(/* #__PURE__ */ Data_Argonaut_Encode_Class.encodeRecord(gEncodeJsonCons8)())))(/* #__PURE__ */ Data_Argonaut_Encode_Generic.encodeRepSum(/* #__PURE__ */ Data_Argonaut_Encode_Generic.encodeRepConstructor(PingFinalIsSymbol)(/* #__PURE__ */ Data_Argonaut_Encode_Generic.encodeRepArgsArgument(/* #__PURE__ */ Data_Argonaut_Encode_Class.encodeRecord(/* #__PURE__ */ gEncodeJsonCons6(gEncodeJsonCons8)(jitterIsSymbol)())())))(/* #__PURE__ */ Data_Argonaut_Encode_Generic.encodeRepSum(/* #__PURE__ */ Data_Argonaut_Encode_Generic.encodeRepConstructor(ModemFinalIsSymbol)(/* #__PURE__ */ Data_Argonaut_Encode_Generic.encodeRepArgsArgument(/* #__PURE__ */ Data_Argonaut_Encode_Class.encodeRecord(/* #__PURE__ */ Data_Argonaut_Encode_Class.gEncodeJsonCons(encodeJsonModemFinalResul)(Data_Argonaut_Encode_Class.gEncodeJsonNil)(modemFinalIsSymbol)())())))(/* #__PURE__ */ Data_Argonaut_Encode_Generic.encodeRepSum(/* #__PURE__ */ Data_Argonaut_Encode_Generic.encodeRepConstructor(WarningIsSymbol)(/* #__PURE__ */ Data_Argonaut_Encode_Generic.encodeRepArgsArgument(Fusion_Data_FSWarning.encodeJsonFSWarning)))(/* #__PURE__ */ Data_Argonaut_Encode_Generic.encodeRepConstructor(FusionDownloadOutputIsSymbol)(/* #__PURE__ */ Data_Argonaut_Encode_Generic.encodeRepArgsArgument(/* #__PURE__ */ Data_Argonaut_Encode_Class.encodeRecord(/* #__PURE__ */ Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonJson)(Data_Argonaut_Encode_Class.gEncodeJsonNil)(loadOutputIsSymbol)())()))))))))))))
};
var decodeJsonModemNotRunReas = {
    decodeJson: /* #__PURE__ */ MST_Encoding.genericDecodeJsonVisonum(genericModemNotRunReason_)(/* #__PURE__ */ Data_Argonaut_Decode_Generic.decodeRepSum(/* #__PURE__ */ Data_Argonaut_Decode_Generic.decodeRepConstructorNoArgs(NotNeededIsSymbol))(/* #__PURE__ */ Data_Argonaut_Decode_Generic.decodeRepSum(/* #__PURE__ */ Data_Argonaut_Decode_Generic.decodeRepConstructorNoArgs(NotAvailableIsSymbol))(/* #__PURE__ */ Data_Argonaut_Decode_Generic.decodeRepConstructorNoArgs(NotACustomerIsSymbol))))
};
var decodeJsonModemFinalResul = {
    decodeJson: /* #__PURE__ */ MST_Encoding.genericDecodeJsonVisonum(genericModemFinalResult_)(/* #__PURE__ */ Data_Argonaut_Decode_Generic.decodeRepSum(/* #__PURE__ */ Data_Argonaut_Decode_Generic.decodeRepConstructorArg(ModemFinalAvailableIsSymbol)(decodeRecord))(/* #__PURE__ */ Data_Argonaut_Decode_Generic.decodeRepSum(/* #__PURE__ */ Data_Argonaut_Decode_Generic.decodeRepConstructorArg(ModemFinalDidNotRunIsSymbol)(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeRecord(/* #__PURE__ */ Data_Argonaut_Decode_Class.gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeFieldId(decodeJsonModemNotRunReas))(Data_Argonaut_Decode_Class.gDecodeJsonNil)(reasonIsSymbol)()())()))(/* #__PURE__ */ Data_Argonaut_Decode_Generic.decodeRepConstructorArg(ModemFinalFailedIsSymbol)(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeRecord(/* #__PURE__ */ gDecodeJsonCons2(messageIsSymbol)()())()))))
};
var decodeJsonIpVersion = {
    decodeJson: /* #__PURE__ */ MST_Encoding.genericDecodeJsonVisonum(genericIpVersion_)(/* #__PURE__ */ Data_Argonaut_Decode_Generic.decodeRepSum(/* #__PURE__ */ Data_Argonaut_Decode_Generic.decodeRepConstructorNoArgs(IPv4IsSymbol))(/* #__PURE__ */ Data_Argonaut_Decode_Generic.decodeRepConstructorNoArgs(IPv6IsSymbol)))
};
var decodeJsonFSValue = {
    decodeJson: /* #__PURE__ */ Data_Argonaut_Decode_Generic.genericDecodeJson(genericFSValue_)(/* #__PURE__ */ Data_Argonaut_Decode_Generic.decodeRepSum(/* #__PURE__ */ Data_Argonaut_Decode_Generic.decodeRepConstructorArg(PrepareResultIsSymbol)(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeRecord(/* #__PURE__ */ Data_Argonaut_Decode_Class.gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeFieldId(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeRecord(/* #__PURE__ */ Data_Argonaut_Decode_Class.gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeFieldId(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeRecord(/* #__PURE__ */ gDecodeJsonCons3(/* #__PURE__ */ gDecodeJsonCons3(/* #__PURE__ */ gDecodeJsonCons3(/* #__PURE__ */ gDecodeJsonCons3(Data_Argonaut_Decode_Class.gDecodeJsonNil)(maxUploadProvisionedSpeedIsSymbol)()())(maxUploadBookedSpeedIsSymbol)()())(maxDownloadProvisionedSpeedIsSymbol)()())(maxDownloadBookedSpeedIsSymbol)()())()))(/* #__PURE__ */ gDecodeJsonCons4(Data_Argonaut_Decode_Class.gDecodeJsonNil)(speedtestIDIsSymbol)()())(contractInfoIsSymbol)()())()))(/* #__PURE__ */ Data_Argonaut_Decode_Class.gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeFieldId(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeRecord(/* #__PURE__ */ Data_Argonaut_Decode_Class.gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeFieldId(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeRecord(/* #__PURE__ */ gDecodeJsonCons2(userAgentIsSymbol)()())()))(/* #__PURE__ */ Data_Argonaut_Decode_Class.gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeFieldId(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeRecord(/* #__PURE__ */ gDecodeJsonCons4(/* #__PURE__ */ Data_Argonaut_Decode_Class.gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeFieldId(decodeJsonIpVersion))(/* #__PURE__ */ gDecodeJsonCons2(ispIsSymbol)()())(ipVersionIsSymbol)()())(ipIsSymbol)()())()))(Data_Argonaut_Decode_Class.gDecodeJsonNil)(connectionIsSymbol)()())(clientIsSymbol)()())()))(/* #__PURE__ */ Data_Argonaut_Decode_Class.gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeFieldId(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeRecord(/* #__PURE__ */ Data_Argonaut_Decode_Class.gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeFieldId(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeRecord(/* #__PURE__ */ Data_Argonaut_Decode_Class.gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeFieldId(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeJsonNonEmptyArray(decodeRecord1)))(/* #__PURE__ */ gDecodeJsonCons6(/* #__PURE__ */ gDecodeJsonCons7(Data_Argonaut_Decode_Class.gDecodeJsonNil)(numStreamsIsSymbol)()())(durationIsSymbol)()())(downloadAddressesIsSymbol)()())()))(/* #__PURE__ */ Data_Argonaut_Decode_Class.gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeFieldId(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeRecord(/* #__PURE__ */ gDecodeJsonCons6(/* #__PURE__ */ gDecodeJsonCons7(/* #__PURE__ */ Data_Argonaut_Decode_Class.gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeFieldId(decodeRecord1))(Data_Argonaut_Decode_Class.gDecodeJsonNil)(uploadAddressIsSymbol)()())(numStreamsIsSymbol)()())(durationIsSymbol)()())()))(Data_Argonaut_Decode_Class.gDecodeJsonNil)(uploadIsSymbol)()())(downloadIsSymbol)()())()))(Data_Argonaut_Decode_Class.gDecodeJsonNil)(stepDetailsIsSymbol)()())(initIsSymbol)()())(infoIsSymbol)()())()))(/* #__PURE__ */ Data_Argonaut_Decode_Generic.decodeRepSum(/* #__PURE__ */ Data_Argonaut_Decode_Generic.decodeRepConstructorArg(DownloadIntermediateIsSymbol)(decodeRecord))(/* #__PURE__ */ Data_Argonaut_Decode_Generic.decodeRepSum(/* #__PURE__ */ Data_Argonaut_Decode_Generic.decodeRepConstructorArg(DownloadFinalIsSymbol)(decodeRecord2))(/* #__PURE__ */ Data_Argonaut_Decode_Generic.decodeRepSum(/* #__PURE__ */ Data_Argonaut_Decode_Generic.decodeRepConstructorArg(UploadIntermediateIsSymbol)(decodeRecord))(/* #__PURE__ */ Data_Argonaut_Decode_Generic.decodeRepSum(/* #__PURE__ */ Data_Argonaut_Decode_Generic.decodeRepConstructorArg(UploadFinalIsSymbol)(decodeRecord2))(/* #__PURE__ */ Data_Argonaut_Decode_Generic.decodeRepSum(/* #__PURE__ */ Data_Argonaut_Decode_Generic.decodeRepConstructorArg(PingIntermediateIsSymbol)(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeRecord(gDecodeJsonCons8)()))(/* #__PURE__ */ Data_Argonaut_Decode_Generic.decodeRepSum(/* #__PURE__ */ Data_Argonaut_Decode_Generic.decodeRepConstructorArg(PingFinalIsSymbol)(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeRecord(/* #__PURE__ */ gDecodeJsonCons6(gDecodeJsonCons8)(jitterIsSymbol)()())()))(/* #__PURE__ */ Data_Argonaut_Decode_Generic.decodeRepSum(/* #__PURE__ */ Data_Argonaut_Decode_Generic.decodeRepConstructorArg(ModemFinalIsSymbol)(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeRecord(/* #__PURE__ */ Data_Argonaut_Decode_Class.gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeFieldId(decodeJsonModemFinalResul))(Data_Argonaut_Decode_Class.gDecodeJsonNil)(modemFinalIsSymbol)()())()))(/* #__PURE__ */ Data_Argonaut_Decode_Generic.decodeRepSum(/* #__PURE__ */ Data_Argonaut_Decode_Generic.decodeRepConstructorArg(WarningIsSymbol)(Fusion_Data_FSWarning.decodeJsonFSWarning))(/* #__PURE__ */ Data_Argonaut_Decode_Generic.decodeRepConstructorArg(FusionDownloadOutputIsSymbol)(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeRecord(/* #__PURE__ */ Data_Argonaut_Decode_Class.gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonJson))(Data_Argonaut_Decode_Class.gDecodeJsonNil)(loadOutputIsSymbol)()())())))))))))))
};
var printWarning = function (v) {
    if (v instanceof Fusion_Data_FSWarning.FSWarningDownloadStreamFailed) {
        return "Download stream failed: " + (MST_Data_BasicURL.print(v.value0) + (" (" + (v.value1 + ")")));
    };
    if (v instanceof Fusion_Data_FSWarning.FSWarningUploadStreamFailed) {
        return "Upload stream failed: " + (MST_Data_BasicURL.print(v.value0) + (" (" + (v.value1 + ")")));
    };
    throw new Error("Failed pattern match at Fusion.Data.FSValue (line 159, column 16 - line 161, column 118): " + [ v.constructor.name ]);
};
var isUploadWarning = function (v) {
    if (v instanceof Fusion_Data_FSWarning.FSWarningUploadStreamFailed) {
        return true;
    };
    return false;
};
var isDownloadWarning = function (v) {
    if (v instanceof Fusion_Data_FSWarning.FSWarningDownloadStreamFailed) {
        return true;
    };
    return false;
};
export {
    PrepareResult,
    DownloadIntermediate,
    DownloadFinal,
    UploadIntermediate,
    UploadFinal,
    PingIntermediate,
    PingFinal,
    ModemFinal,
    Warning,
    FusionDownloadOutput,
    IPv4,
    IPv6,
    ModemFinalAvailable,
    ModemFinalDidNotRun,
    ModemFinalFailed,
    NotNeeded,
    NotAvailable,
    NotACustomer,
    isDownloadWarning,
    isUploadWarning,
    printWarning,
    genericFSValue_,
    eqFSValue,
    showFSValue,
    encodeJsonFSValue,
    decodeJsonFSValue,
    genericIpVersion_,
    eqIpVersion,
    showIpVersion,
    encodeJsonIpVersion,
    decodeJsonIpVersion,
    genericModemFinalResult_,
    eqModemFinalResult,
    showModemFinalResult,
    encodeJsonModemFinalResul,
    decodeJsonModemFinalResul,
    genericModemNotRunReason_,
    eqModemNotRunReason,
    showModemNotRunReason,
    encodeJsonModemNotRunReas,
    decodeJsonModemNotRunReas
};
